import { createContext } from 'react'
import type { User } from 'firebase/auth'
import type { UserProfile } from '@/lib/types'

export type AuthState = {
  /** Firebase Auth is still restoring the session. */
  isLoading: boolean
  user: User | null
  /** `users/{uid}` of the signed-in user; null while loading, or when the document is missing. */
  profile: UserProfile | null
  /** Set when reading the profile failed (offline, or rules rejected the read). */
  error: string | null
  isAdmin: boolean
  signInWithGoogle: () => Promise<void>
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthState | null>(null)
